import { render, staticRenderFns } from "./OperationTicketDetails.vue?vue&type=template&id=284ca813&scoped=true"
import script from "./OperationTicketDetails.vue?vue&type=script&lang=js"
export * from "./OperationTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./OperationTicketDetails.vue?vue&type=style&index=0&id=284ca813&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284ca813",
  null
  
)

export default component.exports